import React, { memo } from 'react';
import { FitoList } from '~/Components';
import { IFitoListReactQueryProps, useFitoListReactQuery } from './useFitoListReactQuery';

const _FitoListReactQuery = <T extends object>(props: IFitoListReactQueryProps<T>) => {
  const fitoListProps = useFitoListReactQuery(props);

  return <FitoList {...fitoListProps} />;
};

export const FitoListReactQuery = memo(_FitoListReactQuery) as typeof _FitoListReactQuery;
